import { UserContextValue } from "contexts/new/UserContext";
import { getPlanWithId } from "data/stripe/StripePlan";
import request from "graphql-request";
import { trackEvent } from "services/frontend/Segment";
import { baseUrl } from "services/shared/Environment";

function trackSignedInMutation(args: {
  firebaseId: string;
  userEmail: string;
  userFullName: string;
}) {
  return `
    mutation {
      trackSignedIn(
        firebaseId:"${args.firebaseId}"
        userEmail:"${args.userEmail}"
        userFullName:"${args.userFullName}"
      )
    }
  `;
}

export const useRecordSignedIn = () => {
  const recordSignedIn = (user: UserContextValue) => {
    trackEvent("Signed In", {
      email: user?.email ?? "",
      plan_name: getPlanWithId(user?.stripePlanId),
      plan_code: user?.stripePlanId ?? "",
    });

    try {
      request(
        `${baseUrl()}/api/graphql`,
        trackSignedInMutation({
          firebaseId: user.firebaseId ?? '',
          userEmail: user.email ?? "",
          userFullName: `${user.firstName ?? ""}  ${user.lastName ?? ""}`,
        })
      );
    } catch (e) {
      console.log(e);
    }
  };

  return recordSignedIn;
};
